import {FC} from 'react';
import {TooltipWrapper} from '@atoms/Tooltip.styles';
import Text from '@atoms/Text';
import {theme} from '@styles/theme';

export interface TooltipProps {
  isVisible: boolean;
  text: string;
  displayOnTop?: boolean;
}

const Tooltip: FC<TooltipProps> = ({isVisible, text, displayOnTop = false}) => {
  return isVisible ? (
    <TooltipWrapper displayOnTop={displayOnTop}>
      <Text text={text} type="tinyR" color={theme.colors.basic08} />
    </TooltipWrapper>
  ) : (
    <></>
  );
};

export default Tooltip;
